import { useEffect } from 'react'
import { Platform } from 'react-native'

const isWeb = Platform.OS === 'web'

export const useInvertScrollWeb = (ref) => {
  useEffect(() => {
    if (isWeb) {
      const scrollNode = ref.current && ref.current.getScrollableNode()
      if (!scrollNode) return

      const invertScroll = (e) => {
        scrollNode.scrollTop -= e.deltaY
        e.preventDefault()
      }

      scrollNode.addEventListener('wheel', invertScroll)
      ref.current.setNativeProps({
        style: { transform: 'translate3d(0,0,0) scaleY(-1)' },
      })
      return () => scrollNode.removeEventListener('wheel', invertScroll)
    }
  }, [ref])
}
